function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button, ButtonGroup, HStack, Icon, IconButton } from '@chakra-ui/react';
import Heading from '@/components/Heading';
import { useLocation, useNavigate, useOutlet } from 'react-router';
import { WebRoutes } from '@/utils/constants';
import DashboardLayout from '@/components/layouts/DashboardLayout';
import SearchInput from '@/components/SearchInput';
import { useSearchQueryState } from '@/hooks/usePaginationQueryState';
import { FormattedMessage, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from 'react-helmet';
export var CommandsLayoutContext = /*#__PURE__*/ React.createContext('');
function CommandsLayout(param) {
    var children = param.children;
    var intl = useIntl();
    var _useSearchQueryState = _sliced_to_array(useSearchQueryState(), 2), search = _useSearchQueryState[0], setSearch = _useSearchQueryState[1];
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    var outlet = useOutlet();
    if (children == null && outlet == null) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "TY8Ho1",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Commands"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Heading, {
                subHeading: intl.formatMessage({
                    id: "9544+J",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Commands are used to trigger responses in chat."
                        }
                    ]
                }),
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "TY8Ho1",
                    defaultMessage: "Commands"
                })
            }),
            /*#__PURE__*/ _jsxs(HStack, {
                spacing: 6,
                children: [
                    /*#__PURE__*/ _jsxs(ButtonGroup, {
                        isAttached: true,
                        size: "sm",
                        borderRadius: "lg",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                backgroundColor: pathname === WebRoutes.COMMANDS_CUSTOM ? undefined : 'backgroundPrimary',
                                variant: pathname === WebRoutes.COMMANDS_CUSTOM ? 'cta' : 'outline',
                                onClick: function() {
                                    return navigate(WebRoutes.COMMANDS_CUSTOM);
                                },
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "Sjo1P4",
                                    defaultMessage: "Custom"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                backgroundColor: pathname === WebRoutes.COMMANDS_DEFAULT ? undefined : 'backgroundPrimary',
                                variant: pathname === WebRoutes.COMMANDS_DEFAULT ? 'cta' : 'outline',
                                onClick: function() {
                                    return navigate(WebRoutes.COMMANDS_DEFAULT);
                                },
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "lKv8ex",
                                    defaultMessage: "Default"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(SearchInput, {
                        display: {
                            base: 'none',
                            sm: 'block'
                        },
                        search: search,
                        setSearch: setSearch,
                        placeholder: intl.formatMessage({
                            id: "HEjycM",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Search commands..."
                                }
                            ]
                        })
                    }),
                    pathname === WebRoutes.COMMANDS_CUSTOM ? /*#__PURE__*/ _jsxs(ButtonGroup, {
                        size: "sm",
                        ml: "auto",
                        variant: "cta",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                onClick: function() {
                                    return navigate(WebRoutes.COMMANDS_CUSTOM_CREATE);
                                },
                                display: {
                                    base: 'none',
                                    sm: 'block'
                                },
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "2xN+AO",
                                    defaultMessage: "New Command"
                                })
                            }),
                            /*#__PURE__*/ _jsx(IconButton, {
                                display: {
                                    base: 'block',
                                    sm: 'none'
                                },
                                onClick: function() {
                                    return navigate(WebRoutes.COMMANDS_CUSTOM_CREATE);
                                },
                                icon: /*#__PURE__*/ _jsx(Icon, {
                                    as: FontAwesomeIcon,
                                    icon: faPlus
                                }),
                                "aria-label": intl.formatMessage({
                                    id: "2xN+AO",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "New Command"
                                        }
                                    ]
                                })
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ _jsx(SearchInput, {
                display: {
                    base: 'block',
                    sm: 'none'
                },
                search: search,
                setSearch: setSearch,
                placeholder: intl.formatMessage({
                    id: "HEjycM",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Search commands..."
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(CommandsLayoutContext.Provider, {
                value: search,
                children: children !== null && children !== void 0 ? children : outlet
            })
        ]
    });
}
export default CommandsLayout;
